// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-slide-group__prev {\n  display: none !important;\n  visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
